export default {
  // Layout
  layout: {
    maxWidth: '1440px',
    paddingInline: '4vw',
  },
  // Border radius
  borderRadius: {
    xsmall: '0.2em',
    small: '0.3em',
    medium: '1em',
    large: '1.5em',
    xlarge: '3em',
  },

  // Spacing
  spacing: {
    xsmall: '0.25rem',
    small: '0.5rem',
    default: '1rem',
    medium: '1.5rem',
    large: '2rem',
    xlarge: '3rem',
    xxlarge: '4rem',
  },
};
